import * as React from "react";
import EdButton from "../../../../generic/edButton";
import ObAssetsDetlMob from "../../instruments/details/obAssetsDetlMob";
import Tab from "../../../../generic/tab";
import ObIpoDtlsContent from "../dsk/obIpoDtlsContent";
import { ObAssetsDetlProps } from "./../../instruments/details/obAssetsDetl";
import moment from "moment";
import { ChipStatusComb } from "./../../obConstants";
import { IListObj } from "../../../../types/genericTypes";

export interface ObIpoDtlsMobProps {
	data: any;
	onBackClick: (event: React.MouseEvent<HTMLButtonElement>) => void; // the function to be called onClick
	onCancelClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const ObIpoDtlsMob: React.FC<ObIpoDtlsMobProps> = (props) => {
	//for back button
	const backButtonValue = (
		<>
			<i className="arrow_left edel-icon-arrow-left vTextTop" />
			<span>Back</span>
		</>
	);
	const tabLst: Array<IListObj> = [{ value: "info", display: "Info" }];

	const assetDetail: ObAssetsDetlProps = {
		date: props.data.submitDt ? moment(new Date(props.data.submitDt)).format("D MMM YYYY, HH:mm:ss") : "",
		trsTyp: "BUY",
		title: props.data.ipoNm,
		sts: ChipStatusComb[props.data.sts.toLowerCase()]
	};

	return (
		<div>
			<section className="ob_detail_container">
				<section className="ob_detail_wrapper">
					<section className="ob_mob ly_mob ">
						<div className="ob_title ly_title  bckBtnDiv">
							{/* back button */}
							<EdButton value={backButtonValue} btnTyp="link" onClick={props.onBackClick} className="icon_button" />
						</div>
						<div className="lv_header">
							<ObAssetsDetlMob {...assetDetail} />
							{/* when status is rejected will show below content */}
							{props.data.applStatus[0].progress === "Failed" && (
								<div className="rjct_reason">
									<p className="rsn_hd">Reason</p>
									<p className="rsn">{props.data.applStatus[0].text || props.data.applStatus[0].reason}</p>
								</div>
							)}
						</div>
						<div className="ob_content_mob ly_content_mob ">
							{/* detailed content */}
							<div>
								<Tab defaultValue={"info"} tabList={tabLst} onSelect={() => {}} position="left" />
								<ObIpoDtlsContent data={props.data} onCancelClick={props.onCancelClick} />
							</div>
						</div>
					</section>
				</section>
			</section>
		</div>
	);
};

export default ObIpoDtlsMob;
